
<div class="inner-adjust">
    <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1>Administration</h1>
    </div>
    <!-- Show user data when logged in -->
    <div class="row">
      <div class="col-md-12">
        <div class="media">
          <div class="media-body">
            <ul class="list-unstyled">
              <li><a routerLink="setCrimson" routerLinkActive="active">Changer le nombre de crimson d'un personnage</a></li>
              <li><a routerLink="datadumpPersonnage" routerLinkActive="active">Rapport rapide de background et compétences</a></li>
              <li><a routerLink="desinscription" routerLinkActive="active">Désinscription</a></li>
              <li><a routerLink="listeFichePersonnage" routerLinkActive="active">Administration d'une fiche de personnage</a></li>
              <li><a routerLink="competences" routerLinkActive="active">Gestionnaire de compétences</a></li>
              <li><a routerLink="sorts" routerLinkActive="active">Gestionnaire de talents</a></li>
              <li><a routerLink="listReport" routerLinkActive="active">Afficher les signalement de problèmes</a></li>
              <li><a routerLink="listLog" routerLinkActive="active">Log d'administration</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>